
















































import { listFactory } from '@/main/pages';
import { approveButton, rejectButton } from '@/main/utils/tableOperations';
import { REMARK_STATUS } from '@/modules/servis/zakazka/zakazkovyList/constants';

import { showConfirm, showAlert } from '@/main/utils/notifications';

import { NAME } from './constants';
import { store } from './store/list';
import { apiProvider } from './api';

export default listFactory(NAME, store).extend({
	data() {
		return {
			confirmationDialog: {
				visible: false,
				notificationDialogMsg: null as string | null,
				handleClose: () => {},
			},
			statusDialog: {
				visible: false,
				notificationDialogMsg: null as string | null,
				handleClose: () => {},
			},
		};
	},
	computed: {
		approvalRequestType(): boolean {
			if (this.table.rows.length !== 0 && this.table.rows[0].cells[this.table.cellNames!.Watchlisted] === 0) {
				return true;
			}

			return false;
		},
		extraButtons(): {} {
			return {
				...approveButton((e: any, cells: any) => this.openWarningDialog(
					cells[this.table.cellNames!.WATCHLISTEDVEHICLESDETAILS_ID],
					cells[this.table.cellNames!.REMARK],
					true,
				)),
				...rejectButton((e: any, cells: any) => this.openWarningDialog(
					cells[this.table.cellNames!.WATCHLISTEDVEHICLESDETAILS_ID],
					cells[this.table.cellNames!.REMARK],
					false,
				)),
			};
		},
	},
	methods: {
		async approveRequest(id: number) {
			this.confirmationDialog.visible = false;
			this.refreshPreviousPage = true;
			this.startLoading();
			const resp = await this.approveItem(id, this.Remark);
			this.endLoading();
			if (resp.data) {
				showAlert({
					message: `${this.LocalizeChyboveHlasky('watchListedApprovalStatus')}`,
					title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
					options: {
						type: 'info',
					},
				});
			}
			this.refreshTable();
		},
		async rejectRequest(id: number) {
			this.confirmationDialog.visible = false;
			this.refreshPreviousPage = true;
			this.startLoading();
			const resp = await this.rejectItem(id, this.Remark);
			this.endLoading();
			if (resp.data) {
				showAlert({
					message: `${this.LocalizeChyboveHlasky('watchListedRejectStatus')}`,
					title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
					options: {
						type: 'info',
					},
				});
			}
			this.refreshTable();
		},
		async refreshTable() {
			this.startLoading();
			await this.tableData();
			this.endLoading();
			(this.$refs.table as any).refreshLayout();
		},

		async approveItem(id: number, remark: string | null) {
			const resp = await apiProvider.approveItem(id, remark);
			return resp;
		},

		async rejectItem(id: number, remark: string | null) {
			const resp = await apiProvider.rejectItem(id, remark);
			return resp;
		},

		openWarningDialog(CellID: number, remark: string, approval: boolean) {
			this.Remark = remark;
			this.confirmationDialog.visible = true;
			this.confirmationDialog.notificationDialogMsg = 'Remark';
			this.confirmationDialog.handleClose = () => {
				if (approval) this.approveRequest(CellID);
				else this.rejectRequest(CellID);
			};
		},
	},
});
